import { useIsCommunityAdmin } from "@circle-react/contexts/punditUserContext";
import { creditBalanceQueries } from "@circle-react/lib/queries/credits";
import { useQuery } from "react-query";

interface UseCreditBalanceOptions {
  enabled?: boolean;
}

const ONE_MINUTE_IN_MS = 60_000;

export const useCreditBalance = ({
  enabled = true,
}: UseCreditBalanceOptions = {}) => {
  const isAdmin = useIsCommunityAdmin();
  return useQuery({
    ...creditBalanceQueries.balance(),
    enabled: enabled && isAdmin,
    staleTime: 10 * ONE_MINUTE_IN_MS,
    gcTime: 10 * ONE_MINUTE_IN_MS,
  });
};
